import { MainLayout } from '@/layouts/main';
import ProfileHeader from '@/widgets/profile/ui/ProfileHeader';
import LoyaltyInfo   from '@/widgets/profile/ui/LoyaltyInfo';
import PromoSection  from '@/widgets/profile/ui/PromoSection';
import GamesHistory  from '@/widgets/profile/ui/GamesHistory';
import useProfileData from '@/widgets/profile/model/useProfileData.js';
import { useNavigate } from 'react-router-dom';

export default function ProfileWidget() {
    const nav = useNavigate();
    const {
        user, setUser,
        games, totalElements,
        loadingUser, loadingGames,
        lastPage, loadGames,
        generateCode, isCodePending
    } = useProfileData();

    const selfPromo = user?.myCode ?? '';
    const selfCodeCount = user?.myCodeCountUse ?? 0;

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        setUser(null);
        nav('/');
    };

    if (loadingUser) return <MainLayout><p className="par1 text-center mt-5">Загрузка…</p></MainLayout>;
    if (!user)       return <MainLayout><p className="par2 text-center mt-5">Профиль не найден</p></MainLayout>;

    return (
        <MainLayout>
            <ProfileHeader user={user} onLogout={handleLogout} generateCode={generateCode} isCodePending={isCodePending}/>
            <LoyaltyInfo  user={user} />
            <PromoSection code={selfPromo} count={selfCodeCount}/>
            <GamesHistory
                games={games}
                total={totalElements}
                lastPage={lastPage}
                loading={loadingGames}
                onLoadMore={loadGames}
            />
        </MainLayout>
    );
}
